(() => {

    function initDiagramSlider(slider) {

        if (slider.swiper) {
            slider.swiper.destroy(true, true);
        }

        new Swiper(slider, {

            speed: 700,
            centeredSlides: true,
            slidesPerView: 1.2,
            spaceBetween: 5,
            autoHeight: true,
            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: slider.querySelector('.swiper-pagination'),
                clickable: true,
            },

            breakpoints: {
                1300: {
                    slidesPerView: 1.7,
                    centeredSlides: true,
                    spaceBetween: 20,
                }
            }

        });

    }

    function initAll() {
        document.querySelectorAll('.eg-product-diagram-panel__slider')
            .forEach(initDiagramSlider);
    }

    document.addEventListener('DOMContentLoaded', initAll);

    document.addEventListener('shopify:section:load', (e) => {
        e.target
            .querySelectorAll('.eg-product-diagram-panel__slider')
            .forEach(initDiagramSlider);
    });

})();
